export enum MessageType {
    Status = 'status',
    Log = 'log',
}
